import React from "react";
import { StyledClientReply } from "./EnquiryDoableStyles";

// Renders a client's reply verbatim. Splitting on blank lines into <p> paragraphs gives
// the reply Juno's message rhythm; pre-line keeps single line breaks within a paragraph.
// Text is React children, so markup the client typed (e.g. **stars**) stays literal.
export default function ClientReply({ content }) {
  const text = content == null ? "" : content.trim();
  if (text === "") return null;

  const paragraphs = text.split(/\n{2,}/);

  return (
    <StyledClientReply>
      {paragraphs.map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
      ))}
    </StyledClientReply>
  );
}
